import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    oauthLabel: {
      width: '100%',
      textAlign: 'center',
      margin: theme.spacing(3, 'auto'),
      display: 'table',
      whiteSpace: 'nowrap',
      color: COLORS.gray.gray40,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),

      '&:before, &:after': {
        borderTop: `1px solid ${COLORS.gray.gray40}`,
        content: '""',
        display: 'table-cell',
        position: 'relative',
        top: '0.6em',
        width: '43%',
      },
    },
  }),
  { name: 'AuthTypeSeparator' }
);
